<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'OpenSessionsDataProvider',
  created() {
    this.fetchItems();
  },
  methods: {
    ...mapActions('OpenSessions', ['fetchItems', 'register', 'unregister'])
  },
  computed: {
    ...mapGetters('OpenSessions', [
      'getItems',
      'isLoading',
      'failed',
      'isPending',
      'myRegisteredItems',
      'myRegisteredCount'
    ])
  },
  render() {
    return this.$scopedSlots.default({
      sessions: this.getItems,
      registeredSessions: this.myRegisteredItems,
      registeredCount: this.myRegisteredCount,
      loading: this.isLoading,
      failed: this.failed,
      isPending: this.isPending,
      refresh: () => this.fetchItems(),
      register: (id) => this.register(id),
      unregister: (id) => this.unregister(id)
    });
  }
};
</script>
